<p-toast></p-toast>

<div class="card">
   
    <p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>
    <p-dialog [(visible)]="windowDialog" [style]="{width: '750px',height: '750px'}" header="Ayuda {{optionId}}" [modal]="false" styleClass="p-fluid" 
        closeOnEscape="false" [closable]="false">
        <div>
            <label class="p-error">{{textUser}}</label>
        </div>
        <ng-template pTemplate="content">
            <div class="p-field">
                <h6 *ngIf="!this.userCanEdit">Objetivo:</h6>   
                <label for="objective" *ngIf="this.userCanEdit">Objetivo: *</label>
                <input type="text" pInputText id="objective" *ngIf="this.userCanEdit" [(ngModel)]="optionAssist.objective" required autofocus />
                <label for="objective" *ngIf="!this.userCanEdit">{{this.optionAssist.objective}}</label>
                <small class="p-error" *ngIf="this.userCanEdit && !optionAssist.objective">Objetivo es requerido.</small>
            </div>
            <div class="p-field">    
                <h6 *ngIf="!this.userCanEdit">Caracteristicas:</h6>
                <label for="characteristics" *ngIf="this.userCanEdit">Caracteristicas: *</label>
                <input type="text" pInputText id="characteristics" *ngIf="this.userCanEdit" [(ngModel)]="optionAssist.characteristics" required autofocus [disabled]="!this.userCanEdit"/>
                <label for="characteristics" *ngIf="!this.userCanEdit">{{this.optionAssist.characteristics}}</label>
                <small class="p-error" *ngIf="this.userCanEdit && !optionAssist.characteristics">Cacacteristicas es requerido.</small>
            </div>      
            <div class="p-field">
                <h6 *ngIf="!this.userCanEdit">Observaciones:</h6>    
                <label for="observations" *ngIf="this.userCanEdit">Observaciones: *</label>
                <input type="text" pInputText id="observations" *ngIf="this.userCanEdit" [(ngModel)]="optionAssist.observations" required autofocus [disabled]="!this.userCanEdit"/>
                <label for="observations" *ngIf="!this.userCanEdit">{{this.optionAssist.observations}}</label>
                <small class="p-error" *ngIf="this.userCanEdit && !optionAssist.observations">Observaciones es requerido.</small>
            </div>
            <div class="p-field">    
                <h6 *ngIf="!this.userCanEdit">Resultados:</h6> 
                <label for="results" *ngIf="this.userCanEdit">Resultados: *</label>
                <input type="text" pInputText id="results" *ngIf="this.userCanEdit" [(ngModel)]="optionAssist.results" required autofocus [disabled]="!this.userCanEdit"/>
                <label for="results" *ngIf="!this.userCanEdit">{{this.optionAssist.results}}</label>
                <small class="p-error" *ngIf="this.userCanEdit && !optionAssist.results">Resultados es requerido.</small>
            </div>

            <div class="p-field"> 
                    <button pButton pRipple type="button" label="Ver reglas definidas" class="p-button-info p-button-text" (click)="goToRules()"></button>
            </div>    

            
        </ng-template>
        <ng-template pTemplate="footer">
            <button pButton pRipple label="Cancelar" icon="pi pi-times" class="p-button-danger p-button-text" (click)="hideDialog()" *ngIf="this.userCanEdit"></button>
            <button pButton pRipple label="Guardar" icon="pi pi-check" class="p-button-success p-button-text" (click)="createUpdateAssist()" *ngIf="this.userCanEdit"></button>    
            
        </ng-template>
        
    </p-dialog>
    
</div>